import {Injectable, Injector} from "@angular/core";
import {CustomObjectEntityModel} from "./custom-object-entity.model";

@Injectable()
export class MembershipTypeCustomObjectEntityModel extends CustomObjectEntityModel {
    constructor(injector: Injector) {
        super(injector);
    }

    override getResource(): string {
        return "custom-membership-group";
    }
}
